import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";

const benefits = [
  {
    icon: "ri-layout-grid-line",
    title: "Your Own Farm Listing",
    text: "Get a beautiful, honest profile for your farm with photos, crops, location and your family's story.",
    theme: "primary" as const,
  },
  {
    icon: "ri-lightbulb-line",
    title: "Experience Design Help",
    text: "We work with you to shape activities around your crops, seasons and what you enjoy sharing.",
    theme: "accent" as const,
  },
  {
    icon: "ri-calendar-check-line",
    title: "Visitor Bookings",
    text: "Schools, families, corporates and travellers reach out — and you decide which dates work for you.",
    theme: "secondary" as const,
  },
  {
    icon: "ri-megaphone-line",
    title: "Digital Promotion",
    text: "We showcase your farm across our website, stories and social channels so the right people find you.",
    theme: "primary" as const,
  },
  {
    icon: "ri-secure-payment-line",
    title: "Friendly Settlements",
    text: "Transparent terms and prompt payments for every visit you host, with no hidden deductions.",
    theme: "accent" as const,
  },
  {
    icon: "ri-user-star-line",
    title: "Training & Support",
    text: "Simple hospitality guidance, safety basics and a dedicated point of contact on our team.",
    theme: "secondary" as const,
  },
];

const themeClasses: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function PartnerBenefits() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <Reveal className="max-w-3xl mb-10 md:mb-14">
          <div className="flex items-center gap-3 mb-5">
            <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
            <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-600">
              Why Partner With Us
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl leading-tight text-foreground-950 font-semibold">
            A Fairer Deal for the People Who Grow Our Food
          </h2>
          <p className="mt-5 text-base md:text-lg text-foreground-700 leading-relaxed">
            We built Rythugaru to put farmers first. Partnering with us means added income, new
            skills and a chance to share the knowledge you already carry.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {benefits.map((benefit, index) => (
            <Reveal key={benefit.title} delay={(index % 3) * 80} className="h-full">
              <div className="h-full bg-background-100 rounded-lg border border-background-200 p-6 md:p-7">
                <span
                  className={`w-12 h-12 flex items-center justify-center rounded-full ${themeClasses[benefit.theme]}`}
                >
                  <i className={`${benefit.icon} text-2xl`}></i>
                </span>
                <h3 className="font-heading text-xl text-foreground-950 font-semibold mt-5">
                  {benefit.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mt-3">{benefit.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}